Common.Views.Modal = Backbone.View.extend({
	tagName: 'div',
	className: 'b-modal',
	template: Handlebars.compile($('#block_modal').html()),
	rolloverTemplate: Handlebars.compile($('#block_rollover').html()),
	rolloverSignerTemplate: Handlebars.compile($('#block_rollover_signer').html()),
	callback: null,
	allModals: [],

	events: {
		'click .js-popup-close': 'clickCloseButton',
		'click .js-popup-button--cancel': 'clickCloseButton',
		'click .js-popup-button--cancel_all': 'hideAllModals',
		'click .js-button--ok': 'clickOkButton',
		'click .js-popup-link': 'clickPopupLink',
		'click .js-popup-button--check_files': 'checkFiles',
		'change .js-field-file[name^="signatures."]': 'changeSignatureFieldFile'
	},

	initialize: function() {
		Common.Views.Modal.__super__.initialize = $.noop;
	},

	createNewModal: function (params, callback) {
		params = params || {};

		var newModal = new Common.Views.Modal;

		_.each(this.allModals, function (modal) {
			if (!modal.isHigherPriority || params.isHigherPriority) {
				modal.hide(true);
			}
		});

		this.allModals.push(newModal);

		newModal.initParams = params;

		// Не используем extend, чтобы в унаследованных вьюхах нормально работал constructor.__super__.
		newModal.show = function () {
			Common.view.partials.$modal.hide();

			this.render(params);

			if (params.extraMenu) {
				Common.get('ExtraMenuModal').view.render(params.extraMenu);
			}

			this.isHigherPriority = params.isHigherPriority;

			this.callback = callback;

			Common.view.partials.$modal.show();

			!params.isBlocker && this.toggleEscListener(true);
			
			if (Common.view.partials.$modal.children().length > 1) {
				this.hide(true);
			}

			if (params.afterShowCallback) {
				params.afterShowCallback.call(this);
			}

			return this;
		};

		newModal.allModals = this.allModals;

		return newModal;
	},

	render: function(params) {
		params = _.extend({
			type: 'custom',
			buttons: false,
			closeButton: true,
			preloader: true
		}, params);

		params.okButton = !params.buttons && !params.isBlocker;

		this.$el
			.html(this.template(params))
			.appendTo(Common.view.partials.$modal);
	},

	remove: function () {
		this.$el.remove();
		this.undelegateEvents();
	},

	show: function(params, callback) {
		return this.createNewModal(params, callback).show();
	},

	toggleEscListener: function(on) {
		Common.view.partials.$window[on ? 'on' : 'off']('keyup.modal_esc_close', on && function(event) {
			if (event && event.keyCode == 27 && Common.view.partials.$modal.find(this.$el).length) {
				this.hide();
			}
		}.bind(this));
	},

	hide: function(isNotDestroy) {
		isNotDestroy = _.isBoolean(isNotDestroy) ? isNotDestroy : false;

		this.remove();

		if (!isNotDestroy) {
			for (var i = 0, max = this.allModals.length; i < max; i++) {
				if (this.allModals[i] === this) {
					this.allModals.splice(i, 1);
				}
			}

			if (this.allModals.length) {
				/* TODO: Возможно, стоит дополнить логику проверкой наличия приоритетных закрытых попапов,
				 * но сейчас эта логика излишняя.
				 */			
				var lastModal = _.last(this.allModals);

				lastModal
					.$el
					.appendTo(Common.view.partials.$modal);

				Common.view.partials.$modal.hide();

				if (!lastModal.initParams.isNotRerender) {
					lastModal.render(lastModal.initParams);

					if (lastModal.initParams.extraMenu) {
						MyArbitr.get('ExtraMenuModal').view.render(lastModal.initParams.extraMenu);
					}
				}

				Common.view.partials.$modal.show();

				if (lastModal.initParams.afterShowCallback) {
					lastModal.initParams.afterShowCallback.call(lastModal);
				}

				lastModal.delegateEvents();
			} else {
				Common.view.partials.$modal.hide();
				this.toggleEscListener();
			}

			if (this.initParams && this.initParams.afterHideCallback) {
				this.initParams.afterHideCallback.call(this);
			}

			// Depricated
			this.callback && this.callback();
		}
	},

	hideAllModals: function () {
		while (this.allModals.length) {
			this.allModals[0].hide();
		}

		return false;
	},

	// Обработчики событий
	clickCloseButton: function() {
		this.hide();
		return false;
	},

	clickOkButton: function() {
		this.hide();
		return false;
	},

	clickPopupLink: function() {
		return false;
	},

	checkFiles: function () {
		var self = this,
			fileReader = new FileReader(),
			$checkForm = this.$el.find('.js-check_form'),
			$files = $checkForm.find('.js-field-file'),
			$act = $files.filter('input[name="act"]'),
			$signatures = $files.filter('input[name^="signatures."]'),
			isActAttached = !!$act.val(),
			isAnySignatureAttached = !!$signatures.val();

		if (_.some($files, 'isInvalidExtesion')) {
			Common.view.showNotificator('Прикреплены некорректные файлы');

			return false;
		}

		if (!isActAttached) {
			$act
				.closest('.js-field')
				.addClass('b-field--error js-field--error');
		}

		if (!isAnySignatureAttached) {
			$signatures
				.closest('.js-field')
				.addClass('b-field--error js-field--error');
		}

		if (!isActAttached || !isAnySignatureAttached) {
			Common.view.showNotificator('Не все обязательные файлы прикреплены');

			return false;
		}

		var params = {
				act: {
					actId: this.$el.find('input[name="actId"]').val(),
					caseId: this.$el.find('input[name="caseId"]').val(),
					index: 0
				},
				signatures: []
			},
			fileReaderQuery = [{
				dist: params.act,
				file: $act[0].files[0]
			}];

		$signatures.each(function (i, sign) {
			if (sign.files[0]) {
				params.signatures[i] = {
					index: i
				};

				fileReaderQuery.push({
					dist: params.signatures[i],
					file: sign.files[0]
				});
			}
		});

		function setBase64Content () {
			var item = fileReaderQuery.shift();

			if (item) {
				fileReader.readAsDataURL(item.file);

				fileReader.onload = function () {
					item.dist.base64Content = fileReader.result.substr(fileReader.result.indexOf(',') + 1);

					setBase64Content();
				};
			} else {
				self.initParams.model.checkFiles(_.extend({
					_onStartLoadingHandler: function () {
						self.$el.addClass('b-preloader');
					},
					options: {
						complete: function () {
							self.$el.removeClass('b-preloader');
						}
					}
				}, params), function (data) {
					var result = data && data.result,
						OK = 'Ok',
						LESS_SIGNATURE = 'LessSignature';

					if (result) {
						var signersInfo = (function () {
								var res = {};

								_.each(result.signerInfo, function (info) {
									res[info.index] = info;
								});

								return res;
							})(),
							isFail = false,
							actMessages = [result.actCheckStatus === OK ? 'Файл документа соответствует судебному акту в КАД' : 'Файл судебного акта не соответствует судебному акту в КАД'],
							$actField = $act.closest('.js-field');

						if (result.actCheckStatus !== OK || result.signatureCheckStatus === LESS_SIGNATURE) {
							if (result.signatureCheckStatus === LESS_SIGNATURE) {
								actMessages.push('Судебный акт подписан коллегиально. Отсутствует один или несколько файлов электронных подписей судей');
							}

							$actField.addClass('b-field--error js-field--error');
							
							isFail = true;
						}

						$actField
							.find('.js-field-delete')
							.replaceWith(self.rolloverTemplate({
								text: actMessages.join('<br><br>')
							}));

						$signatures.each(function (i, file) {
							if (file.files.length) {
								var $file = $(file),
									$field = $file.closest('.js-field'),
									signerInfo = signersInfo[i],
									signMessages = [];

								if (signerInfo) {
									signMessages.push('Файл подписи соответствует данным КАД');

									signMessages.push(self.rolloverSignerTemplate(signerInfo));

									if (signerInfo.verifyErrorMessage) {
										$field.addClass('b-field--error js-field--error');

										isFail = true;
									}
								} else {
									$field.addClass('b-field--error js-field--error');

									signMessages.push('Файл подписи не соответствует данным КАД');

									isFail = true;
								}

								$field
									.find('.js-field-delete')
									.replaceWith(self.rolloverTemplate({
										text: signMessages.join('<br><br>')
									}));
							}
						});

						self.$el.addClass(isFail ? 'b-modal--fail' : 'b-modal--success');
					}
				});
			}
		}

		setBase64Content();

		return false;
	},

	changeSignatureFieldFile: function (e) {
		var $file = $(e.currentTarget),
			$field = $file.closest('.js-field');

		if (e.currentTarget.files[0]) {
			var $newField = $field.clone();

			this.incrementOrChangeSignatureAttributeValue($newField, 'id');
			this.incrementOrChangeSignatureAttributeValue($newField, 'for');

			this.incrementOrChangeSignatureLabelText($newField);

			$newField.find('.js-field-file').val(null);

			$newField
				.removeClass('b-field--error js-field--error')
				.insertAfter($field);

			this.$el.scrollTop(this.$el.scrollTop() + this.$el.height());
		} else {
			$field.remove();

			var $files = this.$el.find('input[name^="signatures."]');

			$files.each(function (i, elem) {
				var $field = $(elem).closest('.js-field');

				this.incrementOrChangeSignatureAttributeValue($field, 'id', i);
				this.incrementOrChangeSignatureAttributeValue($field, 'for', i);

				this.incrementOrChangeSignatureLabelText($field, i + 1);
			}.bind(this));
		}
	},

	incrementOrChangeSignatureAttributeValue: function ($field, attributeName, newVal) {
		$field.find('[' + attributeName + ']').each(function (i, elem) {
			var newValArr = elem.getAttribute(attributeName).split('.');

			if (newVal) {
				newValArr[1] = newVal;
			} else {
				newValArr[1]++;
			}

			elem.setAttribute(attributeName, newValArr.join('.'));
		});
	},

	incrementOrChangeSignatureLabelText: function ($field, newVal) {
		var $label = $field.find('.js-field-label'),
			newTextArr = $label.text().split('#');

		if (newVal) {
			newTextArr[1] = newVal;
		} else {
			newTextArr[1]++;
		}

		$label.text(newTextArr.join('#'));
	}
});
